import React from "react";
import { Alert, type AlertProps } from "@mui/material";

type NotAvailableProps = Omit<AlertProps, "children"> & {
  message?: React.ReactNode;
};

const NotAvailable = ({
  message = "There are none right now.",
  ...rest
}: NotAvailableProps) => {
  // return <h6 className={`my-2 ${className}`}>{message}</h6>;
  return (
    <Alert severity="info" {...rest}>
      {message}
    </Alert>
  );
};

export default NotAvailable;
